import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Static, legally-reviewed clause text. Clause bodies are sourced from
 * approved Word templates by Haymanot Tesfaye (legal counsel). Templates
 * port this text verbatim — never paraphrase, never reorder.
 *
 * `whitespace-pre-wrap` preserves the line breaks the legal text uses
 * for paragraph spacing within a single clause.
 */
export function ClauseBlock(props) {
    return (_jsxs("div", { className: "my-3", style: { breakInside: 'avoid' }, children: [_jsx("div", { className: "mb-1 text-[11px] font-bold", children: props.title }), _jsx("p", { className: "m-0 whitespace-pre-wrap text-[10.5px] leading-relaxed", children: props.body })] }));
}
//# sourceMappingURL=ClauseBlock.js.map